import { render } from "./BookTypeOption.vue?vue&type=template&id=2ae0deee"
import script from "./BookTypeOption.vue?vue&type=script&lang=ts"
export * from "./BookTypeOption.vue?vue&type=script&lang=ts"
script.render = render

export default script